var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},[_c('section',{staticClass:"main cl"},[_c('h1',[_vm._v(_vm._s(_vm.info.title))]),_vm._v(" "),(_vm.type==4)?_c('h2',[_vm._v("应用简介:")]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"con",class:_vm.type==4?'con4':'',domProps:{"innerHTML":_vm._s(_vm.info.content)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1175a0cf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/m/Agreement.vue
// module id = null
// module chunks = 